// We are using this implementation instead the gatsby#withPrefix
// because the project has support to Chromatic and Storybook.
// Otherwise, these tools would need to have the same webpack
// customizations that gatsby has today
//
// We are doing it today just because we want to drop gatsby and today
// the withPrefix is one of the few features that we use from it
export const withPrefix = (path: string) => {
  if (
    process.env.NODE_ENV === 'production' &&
    !process.env.DEV_EXTENSIONS_MODE
  ) {
    return `/assisted-sales/${path.replace(/^\//, '')}`
  }

  return path
}
